import { HistoryModal } from "./HistoryModal";
import { show } from "@ebay/nice-modal-react";

/**
 * Display a modal dialog containing event history for a single Patient/Responsible Party.
 * @param patientId The ID of the P/RP to display.
 * @returns Promise representing dialog lifetime.
 */
export async function showHistoryModal(patientId: number) {
    return await show(HistoryModal, { patientId });
}
